<template>
  <LinkExpired title="Registration link expired : (">
    <p>The link you are trying to use has expired.</p>
    <p>
      For security and convenience, we deactivate unused registration links to keep agency subdomains available for
      future use. Please sign up again to receive a new link and complete the process.
    </p>

    <template #button>
      <b-button tag="router-link" :to="{ name: ROUTES.SIGN_UP.name }" class="button mt-4" variant="primary">
        Go to Sign Up
      </b-button>
    </template>
  </LinkExpired>
</template>

<script>
import LinkExpired from '@components/sign-up/LinkExpired.vue'

export default {
  name: 'ConfirmationLinkExpired',
  components: { LinkExpired }
}
</script>
